"use strict";

var __createBinding = Object.create ? function (e, t, a, r) {
  void 0 === r && (r = a), Object.defineProperty(e, r, {
    enumerable: !0,
    get: function get() {
      return t[a];
    }
  });
} : function (e, t, a, r) {
  void 0 === r && (r = a), e[r] = t[a];
},
    __setModuleDefault = Object.create ? function (e, t) {
  Object.defineProperty(e, "default", {
    enumerable: !0,
    value: t
  });
} : function (e, t) {
  e.default = t;
},
    __importStar = function __importStar(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (null != e) for (var a in e) {
    "default" !== a && Object.hasOwnProperty.call(e, a) && __createBinding(t, e, a);
  }
  return __setModuleDefault(t, e), t;
},
    __importDefault = function __importDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SlideInfo = void 0;

var react_1 = __importDefault(require("react")),
    Utils = __importStar(require("../utils"));

exports.SlideInfo = function (e) {
  var t = e.activeIndex,
      a = e.itemsCount,
      e = e.renderSlideInfo,
      t = Utils.getSlideInfo(t, a).item;
  return "function" == typeof e ? react_1.default.createElement("div", {
    className: "alice-carousel__slide-info"
  }, e({
    item: t,
    itemsCount: a
  })) : react_1.default.createElement("div", {
    className: "alice-carousel__slide-info"
  }, react_1.default.createElement("span", {
    className: "alice-carousel__slide-info-item"
  }, t), react_1.default.createElement("span", {
    className: "alice-carousel__slide-info-item alice-carousel__slide-info-item--separator"
  }, "/"), react_1.default.createElement("span", {
    className: "alice-carousel__slide-info-item"
  }, a));
};